export const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tableRowRoot: {
    height: '1.5rem',
    letterSpacing: '0.1px',
    '&$:hover': {
      color: 'black',
      opacity: 1,
    },
    '&$:focus': {
      color: 'black',
    },
  },
  tableRowSelected: {
    backgroundColor: '#bbb5b5 !important',
  },
  hover: {},
  btnOptionsRoot: {
    margin: '5px',
  },
  btnOptionsNoBorder: {
    margin: '5px',
    border: 'none',
  },
});
